<template>
	<div class="col-12">
		<ModalInstructions v-if="isModalVisible" @close="isModalVisible=false"></ModalInstructions>
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Llenado de evaluación de Cumplimiento para: <b> {{ user.name }} {{ user.last_name }} - Cargo: {{ user.organization_chart.profile.name }}</b></h3>
			</div>
			<div class="card-body w-full">
				<FillEvaluationScope :evaluation="evaluation || []" :user="user || []"></FillEvaluationScope>                     				
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import request from '../../services/request'
import ModalInstructions from '../../component/evaluations/ModalInstructionsScopes.vue';
import FillEvaluationScope from '../../component/evaluations/FillEvaluationScope.vue';

export default {
	props: {
		evaluation: {
		type: [Object, Array],
		required: true,
		},
		user: {
		type: [Object, Array],
		default: () => [] // Define un valor por defecto
		},
	},
	
	name: "evaluation-fill",
	components: {
		FillEvaluationScope,
		ModalInstructions
	},
	data() {
		return {
			isModalVisible: true,
		}
	},
	async mounted() {
		this.setHeaderTitle('Encuesta');
		await this.evaluationsRequest()
	},
	created() {
		Event.$on("event-load-profiles", () => {
			this.list();
		});
	},
	methods: {
		// async list(page = 1) {
		// 	let service = request;
		// 	let search = this.search;
		// 	let _endpoint = '/profiles';
		// 	try {
		// 		let { data } = await service.list(_endpoint, page, search)
		// 		if (data) {
		// 			this.profiles = data;
		// 		}
		// 	} catch (error) {
		// 		console.log(error);
		// 	}
        // },
        async evaluationsRequest() {
			let service = request;
			let _endpoint = '/evaluations';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.evaluations = data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
		})
	}
}
</script>

<style scoped>
.card-body{
	width: 100%;
	max-height: 75vh;
    overflow-y: overlay;
}
/* General */
* {
  scrollbar-color: #1d4745 #ffffff; /* Color del thumb y del fondo */
  scrollbar-width: thin; /* Ancho del scroll reducido */
}

/* Webkit */
::-webkit-scrollbar {
  width: 12px; /* Ancho del scroll vertical */
  height: 12px; /* Altura del scroll horizontal */
}

::-webkit-scrollbar-track {
  background: #ffffff; /* Fondo blanco del scroll */
  border-radius: 10px; /* Bordes redondeados del track */
  margin: 2px; /* Espaciado para evitar que el thumb toque los bordes */
}

::-webkit-scrollbar-thumb {
  background: #1d4745; /* Color del thumb */
  border-radius: 10px; /* Bordes redondeados del thumb */
  border: 2px solid #ffffff; /* Espaciado entre el thumb y el track */
}

::-webkit-scrollbar-thumb:hover {
  background: #14534f; /* Color más oscuro al pasar el mouse */
}




</style>
